import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  bottomSheet: {
    paddingHorizontal: theme.spacing[6],
    paddingBottom: theme.spacing[8],
  },
  languageContainer: {
    borderRadius: theme.borderRadius.m,
    backgroundColor: colors.backgroundL1Alpha,
    padding: theme.spacing[6],
    gap: theme.spacing[8],
  },
  languageOption: {
    flexDirection: 'row',
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  languageOptionSelected: {
    borderColor: colors.borderSelected,
  },
  textContainer: {
    flex: 1,
    gap: theme.spacing[1],
  },
  radioButtonContainer: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colors.borderPrimary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioButtonContainerSelected: {
    borderColor: colors.borderSelected,
  },
  radioButtonInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: colors.backgroundBrand,
  },
  confirmButton: {
    marginTop: theme.spacing[4],
  },
}));
